<!-- eslint-disable vue-a11y/click-events-have-key-events -->
<template>
  <SamMenu
    class="sam-date-time-filter"
    v-bind="menuProps"
    @open="onMenuOpen"
    @close="onMenuClose"
  >
    <template #activator="{ on, isMenuOpen, toggle }">
      <a
        :class="['sam-date-time-filter__menu-activator', { 'is-disabled': disabled }]"
        v-on="disabled ? {} : on"
        @click.prevent
      >
        <SamChip
          ref="chip"
          sam-type="outlined"
          :label="chipLabel"
          :disabled="disabled"
          :active="isChipActive"
        >
          <template #append>
            <div class="d-flex middle-xs">
              <SamIcon
                v-if="withClear && displayDate"
                class="sam-date-time-filter__clear-icon"
                icon="interface-close"
                size="xs"
                @click.stop="onInputClear"
              />

              <SamIcon
                :class="['sam-date-time-filter__expand-icon', { 'is-flipped': isMenuOpen }]"
                icon="arrow-chevron-down"
                size="sm"
                @click.stop="toggle"
              />
            </div>
          </template>

          <!-- No option selected -->
          <template v-if="!displayDate">
            {{ placeholder }}
          </template>

          <!-- Fallback -->
          <template v-else>
            {{ displayDate }}
          </template>
        </SamChip>
      </a>
    </template>

    <SamCalendar
      ref="calendar"
      class="sam-date-time-filter__calendar"
      v-bind="calendarBoundProps"
      :value="value"
      :only-date="onlyDate"
      :only-time="onlyTime"
      @change="onCalendarDateChange"
    />
  </SamMenu>
</template>

<script>
import SamMenu from '../SamMenu/SamMenu.vue';
import SamCalendar from '../SamCalendar/SamCalendar.vue';
import SamChip from '../SamChip/SamChip.vue';
import SamIcon from '../SamIcon/SamIcon.vue';
import dateTimeMixin from '../../../mixins/dateTimeMixin';

export default {
  name: 'SamDateTimeFilter',
  components: { SamChip, SamCalendar, SamIcon, SamMenu },
  mixins: [dateTimeMixin],
  props: {
    /**
     * The Datepicker's chip placeholder.
     */
    placeholder: {
      type: String,
      default: 'Time frame',
    },
  },
  computed: {
    isChipActive() {
      return !!this.value && !!this.displayDate;
    },
    chipLabel() {
      return this.displayDate ?? this.placeholder;
    },
    dateFormat() {
      if (this.displayDateFormat) return `${this.displayDateFormat}`;
      if (this.onlyDate || this.calendarProps?.onlyDate) return 'd M, Y';
      if (this.onlyTime || this.calendarProps?.onlyTime) return 'H:i';
      return 'd M, Y H:i';
    },
  },
};
</script>

<style scoped lang="scss">
.sam-date-time-filter::v-deep {
  &.sam-menu .menu__content {
    min-width: max-content;
    max-width: max-content;
    padding: 0;
  }

  .sam-date-time-filter__menu-activator {
    display: block;

    .sam-date-time-filter__expand-icon {
      transition: rotate 150ms ease-in-out;

      &.is-flipped {
        rotate: -180deg;
      }
    }

    &.is-disabled {
      cursor: not-allowed;
    }
  }
}
</style>
